import classnames from 'classnames';

type TextLinkProps = {
    className?: string;
    href?: string;
    children: React.ReactNode;
    icon?: React.ReactNode;
    onClick?: () => void;
};

export function TextLink({
    className,
    href,
    children,
    icon,
    ...rest
}: TextLinkProps) {
    const linkClassNames = classnames(
        className,
        'flex cursor-pointer items-center space-x-10 overflow-hidden text-sm font-extrabold uppercase tracking-[2px]',
    );

    return href ? (
        <a className={linkClassNames} href={href} {...rest}>
            <span className="flex-none">{icon}</span>
            <span className="block overflow-hidden overflow-ellipsis whitespace-nowrap">
                {children}
            </span>
        </a>
    ) : (
        <span className={linkClassNames} {...rest}>
            <span className="flex-none">{icon}</span>
            <span className="block overflow-hidden overflow-ellipsis whitespace-nowrap">
                {children}
            </span>
        </span>
    );
}
